module.exports = "pegasus_template/assets/tech/realty/101.png";